// Auto-generated by @decocms/blocks-cli/scripts/generate-sections.ts
// Do not edit manually. Add convention exports to your section files instead.
//
// Supported conventions:
//   export const eager = true       → prefer eager (defers past fold threshold)
//   export const neverDefer = true  → ALWAYS eager, ignores fold threshold
//   export const cache = "listing"  → SWR-cached section loader results
//   export const layout = true      → cached as layout (Header, Footer, Theme)
//   export const sync = true        → bundled synchronously (not lazy-loaded)
//   export const clientOnly = true  → skip SSR (client-only rendering)
//   export const seo = true         → SEO section (provides page head data)
//   export function LoadingFallback → skeleton shown while section loads
//   export const renderJson = false → drop section from ?renderJson (mobile)
//   export const renderJson = (p)=> → project props for ?renderJson (mobile)

import * as _sync0 from "../src/sections/Blog/BlockImage";
import * as _sync1 from "../src/sections/Blog/Callout";
import * as _sync2 from "../src/sections/Blog/CardGroup";
import * as _sync3 from "../src/sections/Blog/Checklist";
import * as _sync4 from "../src/sections/Blog/Code";
import * as _sync5 from "../src/sections/Blog/Comparison";
import * as _sync6 from "../src/sections/Blog/Cta";
import * as _sync7 from "../src/sections/Blog/Divider";
import * as _sync8 from "../src/sections/Blog/Heading";
import * as _sync9 from "../src/sections/Blog/List";
import * as _sync10 from "../src/sections/Blog/Paragraph";
import * as _sync11 from "../src/sections/Blog/Quote";
import * as _sync12 from "../src/sections/Blog/Stat";
import * as _sync13 from "../src/sections/Blog/StatGroup";
import * as _sync14 from "../src/sections/Blog/Steps";
import * as _sync15 from "../src/sections/Blog/Table";
import * as _sync16 from "../src/sections/Blog/Video";
import * as _sync17 from "../src/sections/Footer/Footer";
import * as _sync18 from "../src/sections/Header/Header";
import * as _sync19 from "../src/sections/Images/BannerGrid";
import * as _sync20 from "../src/sections/Images/Carousel";
import * as _sync21 from "../src/sections/Images/ImageGallery";
import * as _sync22 from "../src/sections/LandingPages/RulesBar";
import * as _sync23 from "../src/sections/MetaTags/MetaTags";
import * as _sync24 from "../src/sections/Newsletter/Newsletter";
import * as _sync25 from "../src/sections/Product/BuyTogether";
import * as _sync26 from "../src/sections/Product/CrossSellingShelf";
import * as _sync27 from "../src/sections/Product/ProductDetails";
import * as _sync28 from "../src/sections/Product/ProductShelf";
import * as _sync29 from "../src/sections/Product/SearchTitleAndResult";
import * as _sync30 from "../src/sections/Product/WishlistGallery";
import * as _sync31 from "../src/sections/Seo/SeoBlogListing";
import * as _sync32 from "../src/sections/Seo/SeoPDP";
import * as _sync33 from "../src/sections/Seo/SeoPLP";
import * as _sync34 from "../src/sections/Seo/SeoPage";
import * as _sync35 from "../src/sections/Theme/Theme";
import { LoadingFallback as _fb0 } from "../src/sections/LandingPages/HighlightsSection";
import { LoadingFallback as _fb1 } from "../src/sections/Product/SimpleShelf";

export interface SectionMetaEntry {
  eager?: boolean;
  neverDefer?: boolean;
  deferred?: boolean;
  cache?: string;
  layout?: boolean;
  sync?: boolean;
  clientOnly?: boolean;
  seo?: boolean;
  hasLoadingFallback?: boolean;
  renderJson?: false;
  hasRenderJson?: boolean;
}

export const sectionMeta: Record<string, SectionMetaEntry> = {
  "site/sections/Blog/BlockImage.tsx": { sync: true },
  "site/sections/Blog/Callout.tsx": { sync: true },
  "site/sections/Blog/CardGroup.tsx": { sync: true },
  "site/sections/Blog/Checklist.tsx": { sync: true },
  "site/sections/Blog/Code.tsx": { sync: true },
  "site/sections/Blog/Comparison.tsx": { sync: true },
  "site/sections/Blog/Cta.tsx": { sync: true },
  "site/sections/Blog/Divider.tsx": { sync: true },
  "site/sections/Blog/Heading.tsx": { sync: true },
  "site/sections/Blog/List.tsx": { sync: true },
  "site/sections/Blog/Paragraph.tsx": { sync: true },
  "site/sections/Blog/Quote.tsx": { sync: true },
  "site/sections/Blog/Stat.tsx": { sync: true },
  "site/sections/Blog/StatGroup.tsx": { sync: true },
  "site/sections/Blog/Steps.tsx": { sync: true },
  "site/sections/Blog/Table.tsx": { sync: true },
  "site/sections/Blog/Video.tsx": { sync: true },
  "site/sections/Content/Faq.tsx": { cache: "static" },
  "site/sections/Footer/Footer.tsx": { eager: true, sync: true, layout: true },
  "site/sections/Header/Header.tsx": { eager: true, sync: true },
  "site/sections/Images/BannerGrid.tsx": { eager: true, sync: true, hasLoadingFallback: true },
  "site/sections/Images/Carousel.tsx": { eager: true, sync: true, cache: "listing", hasLoadingFallback: true },
  "site/sections/Images/ImageGallery.tsx": { eager: true, sync: true },
  "site/sections/LandingPages/HighlightsSection.tsx": { hasLoadingFallback: true },
  "site/sections/LandingPages/RulesBar.tsx": { eager: true, sync: true },
  "site/sections/MetaTags/MetaTags.tsx": { eager: true, sync: true },
  "site/sections/Newsletter/Newsletter.tsx": { eager: true, sync: true },
  "site/sections/Product/BuyTogether.tsx": { eager: true, sync: true },
  "site/sections/Product/CrossSellingShelf.tsx": { eager: true, sync: true },
  "site/sections/Product/ProductDetails.tsx": { eager: true, sync: true },
  "site/sections/Product/ProductShelf.tsx": { sync: true, cache: "listing" },
  "site/sections/Product/SearchTitleAndResult.tsx": { eager: true, sync: true, cache: "listing" },
  "site/sections/Product/SimpleShelf.tsx": { hasLoadingFallback: true },
  "site/sections/Product/WishlistGallery.tsx": { eager: true, sync: true },
  "site/sections/Seo/SeoBlogListing.tsx": { eager: true, sync: true },
  "site/sections/Seo/SeoPDP.tsx": { eager: true, sync: true },
  "site/sections/Seo/SeoPLP.tsx": { eager: true, sync: true },
  "site/sections/Seo/SeoPage.tsx": { eager: true, sync: true },
  "site/sections/Social/InstagramPosts.tsx": { cache: "static" },
  "site/sections/Theme/Theme.tsx": { eager: true, sync: true, layout: true },
};

export const syncComponents: Record<string, any> = {
  "site/sections/Blog/BlockImage.tsx": _sync0,
  "site/sections/Blog/Callout.tsx": _sync1,
  "site/sections/Blog/CardGroup.tsx": _sync2,
  "site/sections/Blog/Checklist.tsx": _sync3,
  "site/sections/Blog/Code.tsx": _sync4,
  "site/sections/Blog/Comparison.tsx": _sync5,
  "site/sections/Blog/Cta.tsx": _sync6,
  "site/sections/Blog/Divider.tsx": _sync7,
  "site/sections/Blog/Heading.tsx": _sync8,
  "site/sections/Blog/List.tsx": _sync9,
  "site/sections/Blog/Paragraph.tsx": _sync10,
  "site/sections/Blog/Quote.tsx": _sync11,
  "site/sections/Blog/Stat.tsx": _sync12,
  "site/sections/Blog/StatGroup.tsx": _sync13,
  "site/sections/Blog/Steps.tsx": _sync14,
  "site/sections/Blog/Table.tsx": _sync15,
  "site/sections/Blog/Video.tsx": _sync16,
  "site/sections/Footer/Footer.tsx": _sync17,
  "site/sections/Header/Header.tsx": _sync18,
  "site/sections/Images/BannerGrid.tsx": _sync19,
  "site/sections/Images/Carousel.tsx": _sync20,
  "site/sections/Images/ImageGallery.tsx": _sync21,
  "site/sections/LandingPages/RulesBar.tsx": _sync22,
  "site/sections/MetaTags/MetaTags.tsx": _sync23,
  "site/sections/Newsletter/Newsletter.tsx": _sync24,
  "site/sections/Product/BuyTogether.tsx": _sync25,
  "site/sections/Product/CrossSellingShelf.tsx": _sync26,
  "site/sections/Product/ProductDetails.tsx": _sync27,
  "site/sections/Product/ProductShelf.tsx": _sync28,
  "site/sections/Product/SearchTitleAndResult.tsx": _sync29,
  "site/sections/Product/WishlistGallery.tsx": _sync30,
  "site/sections/Seo/SeoBlogListing.tsx": _sync31,
  "site/sections/Seo/SeoPDP.tsx": _sync32,
  "site/sections/Seo/SeoPLP.tsx": _sync33,
  "site/sections/Seo/SeoPage.tsx": _sync34,
  "site/sections/Theme/Theme.tsx": _sync35,
};

export const loadingFallbacks: Record<string, React.ComponentType<any>> = {
  "site/sections/Images/BannerGrid.tsx": _sync19.LoadingFallback,
  "site/sections/Images/Carousel.tsx": _sync20.LoadingFallback,
  "site/sections/LandingPages/HighlightsSection.tsx": _fb0,
  "site/sections/Product/SimpleShelf.tsx": _fb1,
};

export const renderJsons: Record<string, any> = {};
